import axios from 'axios';
import api from '../config/axios';
import API_ROUTES from '../config/apiRoutes';

// --- (Reutilizar o importar handleApiError) ---
const handleApiError = (error: unknown): never => {
    if (axios.isAxiosError(error) && error.response) {
        // Para blobs, el error puede no venir como JSON
        try {
            const errorText = new TextDecoder("utf-8").decode(error.response.data);
            const errorJson = JSON.parse(errorText);
            throw new Error(errorJson.message || 'Error al generar el reporte.');
        } catch (e) {
             throw new Error('Ocurrió un error en el servidor al generar el reporte.');
        }
    }
    throw new Error('Ocurrió un error de conexión o un problema desconocido.');
};


/**
 * @function downloadFile
 * @description Función de ayuda para iniciar la descarga de un archivo recibido como blob.
 * @param {Blob} blob - El contenido del archivo.
 * @param {string} filename - El nombre con el que se guardará el archivo.
 */
const downloadFile = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

/**
 * @function generarKardexCliente
 * @description Descarga un reporte en Excel con el "Kardex" detallado de un caso.
 * @param {number} caseId - El ID del expediente.
 */
export const generarKardexCliente = async (caseId: number, clientName: string): Promise<void> => {
    try {
        const response = await api.get(API_ROUTES.reportes.generarKardex(caseId), {
            responseType: 'blob', // ¡Muy importante para manejar archivos!
        });
        const filename = `Kardex-${clientName.replace(/ /g, '_')}-${caseId}.xlsx`;
        downloadFile(response.data, filename);
    } catch (error) {
        throw await handleApiError(error);
    }
};


/**
 * @function generarReporteFinanciero
 * @description Descarga un reporte en Excel con los ingresos en un rango de fechas.
 * @param {string} startDate - Fecha de inicio 'YYYY-MM-DD'.
 * @param {string} endDate - Fecha de fin 'YYYY-MM-DD'.
 */
export const generarReporteFinanciero = async (startDate: string, endDate: string): Promise<void> => {
    try {
        const response = await api.get(API_ROUTES.reportes.generarFinanciero(startDate, endDate), {
            responseType: 'blob',
        });
        downloadFile(response.data, `Reporte-Financiero-${startDate}-al-${endDate}.xlsx`);
    } catch (error) {
        throw handleApiError(error);
    }
};